export default "__VITE_ASSET__52196274__"